import Immutable from 'immutable';
import { AppState, AppStateActionParams } from 'records/AppState';
import { MappedSheetQuery } from 'records/MappedSheetQuery';
import { SheetVersion } from 'records/SheetVersion';
import queryMappedSheets from 'utils/queryMappedSheets';

export interface MappedSheetQueryActions {
  setMappedSheetQuery: (
    actionParams: AppStateActionParams,
    nextSheetQuery: MappedSheetQuery
  ) => AppState;

  queryMappedSheets: (actionParams: AppStateActionParams) => AppState;
  initMappedSheetQuery: (actionParams: AppStateActionParams) => AppState;
}

const mappedSheetQueryActions: MappedSheetQueryActions = {
  setMappedSheetQuery: (
    { state }: AppStateActionParams,
    nextMappedSheetQuery: MappedSheetQuery
  ): AppState => {
    const { sheets, mappedSheetVersions } = state();

    const qMappedSheets = queryMappedSheets(
      sheets,
      mappedSheetVersions,
      nextMappedSheetQuery
    );

    const pageIds = qMappedSheets
      .valueSeq()
      .map((sheet) => sheet.versions.last(new SheetVersion()).pageid);

    return state()
      .set('mappedSheetQuery', nextMappedSheetQuery)
      .set('queriedMappedSheets', Immutable.List(pageIds));
  },

  queryMappedSheets: ({ state }: AppStateActionParams): AppState => {
    const { sheets, mappedSheetVersions, mappedSheetQuery } = state();

    const qMappedSheets = queryMappedSheets(
      sheets,
      mappedSheetVersions,
      mappedSheetQuery
    );
    const pageIds = qMappedSheets
      .valueSeq()
      .map((sheet) => sheet.versions.last(new SheetVersion()).pageid);

    return state().set('queriedMappedSheets', Immutable.List(pageIds));
  },

  initMappedSheetQuery: ({ state }: AppStateActionParams): AppState => {
    const { sheets, mappedSheetVersions } = state();
    const mappedSheetQuery = new MappedSheetQuery();

    const qMappedSheets = queryMappedSheets(
      sheets,
      mappedSheetVersions,
      mappedSheetQuery
    );

    const pageIds = qMappedSheets
      .valueSeq()
      .map((sheet) => sheet.versions.last(new SheetVersion()).pageid);

    return state()
      .set('mappedSheetQuery', mappedSheetQuery)
      .set('queriedMappedSheets', Immutable.List(pageIds));
  },
};

export default mappedSheetQueryActions;
